<template>
  <v-container id="webshop-redirect">
    <v-row v-if="busy">
      <v-col class="text-center">
        <v-progress-circular
          :size="150"
          :width="6"
          class="mb-4"
          color="primary"
          indeterminate
        ></v-progress-circular>
        <div>{{ this.$t("message.payment_is_being_processed") }}</div>
      </v-col>
    </v-row>
    <v-row v-else justify="center">
      <v-col>
        <MaterialCardV2
          :icon="getCardIcon"
          color="primary"
          :title="getCardTitle"
        >
          <v-row class="pa-5" align="center">
            <v-col v-if="webshopResult.external_payment_state === 'paid'">
              <v-row class="pa-5" align="center">
                <v-col>
                  <h1>{{ this.$t("label.product") }}:</h1>
                  <h4 class="font-weight-regular">
                    {{ webshopResult.product_name }}
                  </h4>
                </v-col>
                <v-col>
                  <h1>{{ this.$t("label.paid") }}:</h1>
                  <h4 class="font-weight-regular">
                    {{ (webshopResult.amount / 100) | currency }}
                  </h4>
                </v-col>
              </v-row>
              <v-row class="pa-5" align="center">
                <v-col v-if="hasEmail">
                  <h1>{{ this.$t("label.email") }}:</h1>
                  <h4 class="font-weight-regular">
                    {{ this.$store.state.webshop.email }}
                  </h4>
                </v-col>
                <v-col v-if="hasLicensePlate">
                  <h1>{{ this.$t("label.license_plate") }}:</h1>
                  <h4 class="font-weight-regular">
                    {{ this.$store.state.webshop.license_plate }}
                  </h4>
                </v-col>
                <v-col class="pa-">
                  <h1>{{ this.$t("label.qr_code") }}:</h1>
                  <h4>
                    {{ this.$t("message.qr_code_can_be_found_in_mailbox") }}
                  </h4>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row
            class="pa-5"
            v-if="
              isModeEnabledForIntegrator &&
                this.$store.state.config.webshop_configuration.integrator_url
            "
          >
            <v-btn
              size="x-large"
              width="200"
              class="orange darken-2 white--text font-weight-bold"
              :href="
                this.$store.state.config.webshop_configuration.integrator_url
              "
            >
              {{ this.$t("button.back_to_webshop") }}
            </v-btn>
          </v-row>
        </MaterialCardV2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MaterialCardV2 from "@/components/views/MaterialCardV2";

export default {
  name: "WebshopRedirect",
  components: { MaterialCardV2 },
  mounted() {
    if (!this.$store.state.webshop.payment_id) {
      this.webshopResult.external_payment_state === "failed";
      this.busy = false;
    } else {
      setTimeout(() => {
        this.$store
          .dispatch("webshop/getWebshopPaymentUnauthenticated")
          .then(response => {
            this.webshopResult = response.data;
            this.busy = false;
          });
      }, 5000);
    }
  },
  data() {
    return {
      webshopResult: {},
      busy: true
    };
  },
  computed: {
    getCardIcon() {
      return this.webshopResult.external_payment_state === "paid"
        ? "mdi-check"
        : "mdi-alert-circle-outline";
    },
    getCardTitle() {
      return this.webshopResult.external_payment_state === "paid"
        ? "Uw bestelling is succesvol afgerond!"
        : "Uw bestelling is afgerond met een foutmelding.";
    },
    isModeEnabledForIntegrator() {
      return (
        this.$store.state.config.webshop_configuration.mode ===
        "enabled_for_integrator"
      );
    },
    hasEmail() {
      return this.$store.state.webshop.email !== null;
    },
    hasLicensePlate() {
      return this.$store.state.webshop.license_plate !== null;
    }
  }
};
</script>
